import React from 'react';
import { Accordion, AccordionContent, AccordionItem, AccordionTrigger } from '@/components/ui/accordion';
import { STOKVEL_TERMS } from '@/content/stokvelTerms';

const isSubhead = (p) => p.endsWith(':') && p.length < 80;

export const StokvelTerms = () => (
  <Accordion type="multiple" className="w-full" data-testid="stokvel-terms">
    {STOKVEL_TERMS.map((s, i) => (
      <AccordionItem key={s.title} value={`s-${i}`}>
        <AccordionTrigger className="text-sm font-semibold text-stone-800 text-left" data-testid={`stokvel-terms-section-${i}`}>
          {i + 1}. {s.title}
        </AccordionTrigger>
        <AccordionContent>
          <div className="space-y-2 text-sm text-stone-700 leading-relaxed">
            {s.paras.map((p, j) => (
              isSubhead(p)
                ? <p key={j} className="font-semibold text-stone-800 pt-1">{p}</p>
                : <p key={j}>{p}</p>
            ))}
          </div>
        </AccordionContent>
      </AccordionItem>
    ))}
  </Accordion>
);
